import { motion } from "framer-motion"
import React, { useEffect, useState } from "react"
import { Moon, Star, Sun } from "react-feather"
import { setThemeColor } from "../../hooks/setThemeColor"
import { useLanguageStore } from "../../state-management/languageStore"

const ThemeToggle = ({ hasAllowedCookies }) => {
    const t = useLanguageStore((state) => state.translate)
    const [darkMode, setDarkMode] = useState(() => {
        // Check if dark mode is activated in local storage
        const savedMode = localStorage.getItem("darkMode")
        return savedMode ? JSON.parse(savedMode) : false
    })

    useEffect(() => {
        // Save the dark mode state to local storage
        localStorage.setItem("darkMode", JSON.stringify(darkMode))
        setThemeColor()
    }, [darkMode])

    useEffect(() => {
        if (!hasAllowedCookies) return
        localStorage.setItem("darkMode", JSON.stringify(darkMode))
    })

    return (
        <div>
            <h3 className="fg-color-1 font-semibold mb-2">
                {t("theme.title")}
            </h3>
            <button
                className=" w-20 h-8 bg-color-3 border border-neutral-400 dark:border-slate-500 rounded-full overflow-hidden relative"
                onClick={() => setDarkMode(!darkMode)}
            >
                <div className="relative transition-all bg-gradient-to-br from-sky-100 to-sky-300 dark:from-slate-500 dark:to-slate-700 w-full h-full">
                    {!darkMode ? (
                        <>
                            <div className="absolute rounded-full aspect-square w-5/12 bg-neutral-50 left-[2%] -top-2/3" />
                            <div className="absolute rounded-full aspect-square w-5/12 bg-neutral-50 right-[4%] -top-2/3" />
                            <div className="absolute rounded-full aspect-square w-2/12 bg-neutral-50 right-0 -top-[10%]" />
                            <div className="absolute rounded-full aspect-square w-2/12 bg-neutral-100 left-0 -top-[10%]" />
                            <div className="absolute rounded-full aspect-square w-1/2 bg-gradient-to-br from-neutral-50 to-white left-1/2 -translate-x-1/2 -top-[77%]" />
                            <div className="absolute rounded-full aspect-square w-2/3 bg-gradient-to-b from-neutral-100 to-white left-1/2 -translate-x-1/3  -top-[130%]" />
                        </>
                    ) : (
                        <>
                            <div className="absolute text-white left-4 rotate-45 top-1">
                                <Star size={6} fill="white" />
                            </div>
                            <div className="absolute text-white left-2 rotate-12 opacity-30 top-4">
                                <Star size={4} fill="white" />
                            </div>
                            <div className="absolute text-white left-9 opacity-35 -rotate-12 top-4">
                                <Star size={4} fill="white" />
                            </div>
                            <div className="absolute text-white left-14 opacity-75 top-1 -rotate-45">
                                <Star size={3} fill="white" />
                            </div>
                            <div className="absolute text-white left-16 rotate-90 opacity-65 bottom-2">
                                <Star size={7} fill="white" />
                            </div>
                            <div className="absolute text-white left-5 rotate-90 opacity-65 bottom-2">
                                <Star size={5} fill="white" />
                            </div>
                            <div className="absolute text-white right-9 rotate-45 opacity-55 top-1">
                                <Star size={3} fill="white" />
                            </div>
                        </>
                    )}
                </div>

                <motion.div
                    initial={{ x: darkMode ? 48 : 0 }}
                    animate={{ x: darkMode ? 48 : 0 }}
                    transition={{ duration: 0.3 }}
                    className="h-[calc(100%-.5rem)] aspect-square overflow-hidden bg-yellow-400/50 backdrop-blur-sm dark:bg-slate-900/50  rounded-full flex items-center justify-center  absolute top-1 left-1"
                >
                    <motion.div
                        initial={{
                            y: darkMode ? -22 : 0,
                        }}
                        animate={{
                            y: darkMode ? -22 : 0,
                        }}
                        className={`h-full w-full  ${darkMode ? " text-slate-100" : "text-black"}`}
                        transition={{ duration: 0.3 }}
                    >
                        <motion.div
                            animate={{
                                rotate: darkMode ? 90 : 0,
                            }}
                            transition={{ duration: 0.5 }}
                            className="h-full w-full flex items-center justify-center"
                        >
                            <Sun size={16} />
                        </motion.div>
                        <motion.div
                            animate={{
                                rotate: darkMode ? 0 : -90,
                            }}
                            transition={{ duration: 0.5 }}
                            className="h-full w-full flex items-center justify-center"
                        >
                            <Moon size={16} />
                        </motion.div>
                    </motion.div>
                </motion.div>
            </button>
        </div>
    )
}

export default ThemeToggle
